import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import SectionLoading from '../common/SectionLoading';
import DetailsEstimateBreakdownSelfPay from './detailsEstimateBreakdownSelfPay';
import { logUI } from "../../api/andyliticsApi";



const DetailsEstimateBreakdown = props => {
    const [estimateModalOpen, setEstimateModalOpen] = useState(false);
    const { isSelfPay, benefitDetails } = props;

    const toggleEstimateModal = () => setEstimateModalOpen(!estimateModalOpen);

    const EstimateBreakdownModal = () => {
        return (
            <div className="estimate-modal">
                <ul>
                    <li>
                        <span className="label">Deductible:</span> The amount you must pay for health care services before your insurance starts to pay anything.
                        After you meet your deductible, you usually pay a copay or co-insurance for care until you meet your out-of-pocket maximum.
                        Not all plans have deductibles and some deductibles only apply to certain services.
                </li>
                    <li>
                        <span className="label">Copay:</span> A flat fee you pay for a health care service covered by your insurance.
                        It is typically due before we provide services and may vary depending on the service (for example, you may pay a different copay for primary care than for a specialty care visit).
                        Not all plans have copays.
                </li>
                    <li>
                        <span className="label">Co-Insurance:</span> The percentage of costs you pay after you've met your deductible for covered health care services.
                        Your co-insurance is a shared cost between you and your insurance and varies based on the total cost of the service.
                        For example, your policy may cover 80% of the allowed amount and you would be responsible for the remaining 20%.
                        Not all plans have co-insurance.
                </li>
                    <li>
                        <span className="label">Not-Covered:</span>  The amount your insurance does not cover for certain health care services that may be your responsibility to pay.
                </li>
                    <li>Please contact your health or insurance plan for more details on your plan and benefit details.</li>
                </ul>
            </div>
        );
    }

    /* useEffect(() => {
         props.dispatch({ type: types.PRICING_USERSQUOTE_QUOTE, data: { token: window.store.getState().domain.t, qid: props.appointment.messageId } });
     }, [props.quote]);*/

    console.info(`DetailsEstimateBreakdown props`, props);
    try {
        if (props.benefitDetails.length > 0) {
            if (isSelfPay) {
                return <DetailsEstimateBreakdownSelfPay benefitDetails={benefitDetails}/>
            } else {
                return <React.Fragment>{!(props.isSelfPay || props.benefitDetails[0].hasMultipleInsuranceApplied.toLowerCase() === 'true') && <div className={`row estimate-details-panel`}>
                    <div className="col">
                        <div className="row">
                            <div className="col"><h4 className="heading">Estimate Breakdown:<span className="icon-question" onClick={() => setEstimateModalOpen(true)} /></h4></div>
                        </div>
                        {(hiddenCls(props.benefitDetails[0].procedurePricingDetails, "procedureAllowedAmount") !== 'hidden') &&
                            <div className={`row `}>
                                <div className="col-6 label">Total Cost:</div>
                                <div className="col-6 text-right">{formatMoney(sumBenifit(props.benefitDetails[0], 'procedureAllowedAmount'))}</div>
                            </div>
                        }
                        {(hiddenCls(props.benefitDetails[0].procedurePricingDetails, "procedureInsurPays") !== 'hidden') &&
                            <div className={`row `}>
                                <div className="col-6 label">Insurance Pays:</div>
                                <div className="col-6 text-right">{formatMoney(sumBenifit(props.benefitDetails[0], 'procedureInsurPays'))}</div>
                            </div>
                        }
                        <div className="row">
                            <div className="col-12">
                                <hr className="hr-divider" />
                            </div>
                        </div>
                        <div className={`row estimate-total ${hiddenCls(props.benefitDetails[0].patientFinancialResponsibilityDetail.patientFinancialResponsibility)}`}>
                            <div className="col-9 label">Your Out-of-Pocket Estimate:</div>
                            <div className="col-3 label text-right">{formatMoney((props.benefitDetails[0].patientFinancialResponsibilityDetail.patientFinancialResponsibility))}</div>
                        </div>
                        <div className="estimate-total-details">
                            <div className={`row item ${hiddenCls(props.benefitDetails[0].patientFinancialResponsibilityDetail.deductibleApplied)}`}>
                                <div className="col-6 text">Deductible:</div>
                                <div className="col-6 text-right">{formatMoney(props.benefitDetails[0].patientFinancialResponsibilityDetail.deductibleApplied)}</div>
                            </div>
                            <div className={`row item ${hiddenCls(props.benefitDetails[0].patientFinancialResponsibilityDetail.copaymentApplied)}`}>
                                <div className="col-6 text">Copay:</div>
                                <div className="col-6 text-right">{formatMoney(props.benefitDetails[0].patientFinancialResponsibilityDetail.copaymentApplied)}</div>
                            </div>
                            <div className={`row item ${hiddenCls(props.benefitDetails[0].patientFinancialResponsibilityDetail.coinsuranceApplied)}`}>
                                <div className="col-6 text">Co-insurance:</div>
                                <div className="col-6 text-right">{formatMoney(props.benefitDetails[0].patientFinancialResponsibilityDetail.coinsuranceApplied)}</div>
                            </div>
                            <div className={`row item ${hiddenCls(props.benefitDetails[0].patientFinancialResponsibilityDetail.amountNotCovered)}`}>
                                <div className="col-6 text">Not-Covered:</div>
                                <div className="col-6 text-right">{formatMoney(props.benefitDetails[0].patientFinancialResponsibilityDetail.amountNotCovered)}</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <hr className="hr-divider" />
                            </div>
                        </div>
                    </div>
                    <Modal isOpen={estimateModalOpen} toggle={toggleEstimateModal} centered={true}>
                        <ModalHeader toggle={toggleEstimateModal}>Estimate Breakdown</ModalHeader>
                        <ModalBody> {EstimateBreakdownModal()}</ModalBody>
                    </Modal>
                </div>}
                </React.Fragment>;
            }
        } else {
            return <div className={`row estimate-details-panel line-bottom ${props.isSelfPay ? 'hidden' : ''}`}>
                <div className="col"><SectionLoading /></div>
            </div>;
        }
    } catch (ex) {
        logUI("MBHWeb.UI.Estimates.detailsEstimateBreakdown", new Date(), `estimateDetails/${props.msgId}`, props, 'ERROR', ex.message);
        console.error(`detailsEstimateBreakdown exception`, ex);
        return <React.Fragment></React.Fragment>;
    }
}
const sumBenifit = (benifit, field) => {
    let sum = 0;
    benifit.procedurePricingDetails.forEach(pricingDetail => {
        console.info(`detailsEstimateBreakdown sumBenifit for ${field} '${pricingDetail[field]}' isNaN ${isNaN(pricingDetail[field])}`, pricingDetail);
        const value = isNaN(Number.parseFloat(pricingDetail[field])) ? 0 : Number.parseFloat(pricingDetail[field]);
        console.info(`detailsEstimateBreakdown sumBenifit ${field} currentValue ${value}`);
        sum += value;
        console.info(`detailsEstimateBreakdown sumBenifit ${field} currentSum ${sum}`);
    });
    console.info(`detailsEstimateBreakdown sumBenifit ${field} final sum ${sum}`);
    return sum;
}
const hiddenCls = (val, name) => {
    name = name || '';
    //console.info(`detailsEstimateBreakdown hiddenCls the value for ${name} is ${val}`,val);
    try {
        let cls = '';

        switch (name) {
            case 'procedureAllowedAmount':
                if (val && val.length > 0 && val.some(beni => beni.procedureAllowedAmount !== '')) {//!isNaN(Number.parseInt(val[0].procedureAllowedAmount))){
                    //console.info(`detailsEstimateBreakdown hiddenCls the value for ${name} is ${val[0].procedureAllowedAmount}`, val);
                } else {
                    cls = 'hidden';
                }
                break;
            case 'procedureInsurPays':
                if (val && val.length > 0 && val.some(beni => beni.procedureInsurPays !== '')) {
                    //console.info(`detailsEstimateBreakdown hiddenCls the value for ${name} is ${val[0].procedureInsurPays}`, val);
                } else {
                    cls = 'hidden';
                }
                break;
            default:
                if (Array.isArray(val)) {
                    for (let i = 0; i < val.length; i++) {
                        if (isNaN(Number.parseInt(val[i]))) {
                            cls = 'hidden';
                        }
                    }
                } else {
                    if (isNaN(Number.parseInt(val))) {
                        cls = 'hidden';
                    }
                }
        }


        return cls;
    } catch (e) { return 'hidden'; }
}

const formatMoney = (amount) => {
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    return formatter.format(amount);
}


export default DetailsEstimateBreakdown;